import { accessWorkspace } from "apis/auth/member";
import { syncMemberForMessenger } from "apis/member-integration";
import { getUsersMemberList, TUser } from "apis/user/index";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AlertModal from "uis/modal/alert-modal";
import { LoadingModal } from "uis/modal";
import { decrypt, encrypt } from "utils/crypto";

export default function Redirect() {
  const location = useLocation();
  const { added, removed, memberPublicId, encryptWorkspaceId } = useParams<{
    added?: string;
    removed?: string;
    memberPublicId?: string;
    encryptWorkspaceId?: string;
  }>();
  const [openMemberSyncModal, setOpenMemberSyncModal] = useState(false);

  useEffect(() => {
    const fn = location.pathname.split("/")[3];
    switch (fn) {
      case "member-sync":
        if (!encryptWorkspaceId) {
          //* 멤버 동기화 모달 띄우기
          setOpenMemberSyncModal(true);
        }
        if (encryptWorkspaceId) {
          redirectMemberSyncModal(encryptWorkspaceId);
        }
        break;
      default:
        break;
    }
  }, []);

  return (
    <>
      <LoadingModal modalIsOpen={true} />
      <AlertModal
        onChange={() => memberSync(memberPublicId ?? "", added ?? "", removed ?? "")}
        btnTitle="즉시 동기화하기"
        title={
          <p style={{ textAlign: "center" }}>
            즉시 동기화하여 GWS 멤버 변동사항을
            <br />
            반영하시겠습니까?
          </p>
        }
        content={
          <p style={{ textAlign: "center" }}>
            동기화 시, 신규 멤버는 Mile 회원가입 및<br />
            워크스페이스 멤버(Staff 권한)로 등록되며, 삭제 멤버는
            <br />
            워크스페이스의 멤버 목록에서도 삭제됩니다.
          </p>
        }
        modalIsOpen={openMemberSyncModal}
        closeModal={() => {}}
      />
    </>
  );
}

const memberSync = async (memberPublicId: string, added: string, removed: string) => {
  const res = await syncMemberForMessenger(memberPublicId);
  if (res.success) {
    alert(`GWS와 Mile 멤버 간 동기화(${added}인 추가, ${removed}인 삭제)가 완료되었습니다.`);
    window.close();
  } else {
    alert("동기화에 실패했습니다. 멤버 관리 페이지에서 다시 시도해 주세요.");
    window.close();
  }
};

const redirectMemberSyncModal = async (encryptWorkspaceId: string) => {
  //* 링크로 전달 받은 워크스페이스 정보 조회
  const workspaceId = decrypt(encryptWorkspaceId);
  const workspaceList = await getUsersMemberList();

  if (!workspaceList.members)
    window.location.href = `${process.env.REACT_APP_WEB_URL}/setting/서비스%20연동%20관리?tab=admin`;
  const workspace = workspaceList.members?.find((workspace: TUser) => workspace.workspace.id === workspaceId);
  if (!workspace) {
    window.location.href = `${process.env.REACT_APP_WEB_URL}/setting/서비스%20연동%20관리?tab=admin`;
  }
  // //* 워크스페이스 접속
  if (workspace) {
    const res = await accessWorkspace(workspace);
    if (res.success && res.accessToken) {
      if (res.user?.autoLogin) localStorage.setItem("access-token", encrypt(res.accessToken));
      else if (!res.user?.autoLogin) sessionStorage.setItem("access-token", encrypt(res.accessToken));
      localStorage.setItem("mile-state", "OPEN_MEMBER_SYNC_PREVIEW_MODAL");
      window.location.href = `${process.env.REACT_APP_WEB_URL}/setting/서비스%20연동%20관리?tab=admin`;
    }
  }
};
